/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    func, shape, array, object, number, string, bool,
} from 'prop-types';
import { Button, Grid, CircularProgress } from '@material-ui/core';
import Calendar from 'react-calendar';
import { withStyles } from '@material-ui/core/styles';
import { ModifyDatesStyle as calendarStyle } from '../../../../style/ModifyDatesStyle';
import { isEmpty } from '../../../../utils/object';
import { dateMMMMDDYYYY, DDMMMYY } from '../../../../utils/dateString';
import configENV from '../../../../config';
import Helper from '../../../../state/reducers/Helper';

const { PERSIST_KEY } = configENV;

const styles = ({ palette, breakpoints }) => calendarStyle(palette, breakpoints);

const ModifyDate = ({
    deliveryDatesResponse, fetchDeliveryDates, classes, ROSSOrder,
    itemDetail, recipient, setModifiedDate, responseStatus, modifiedDate, changeTabs, originalDate,
    getModifiedDeliveryMethod, isRecipientAddressChanged, modifiedRecipientAddress,
    clearProductAvilability, productAvilableStatus, productAvailable, promCodeFlag = false,
    checkForConfirmationScreen, modifyEligibility,
}) => {
    const formatedSelectedDate = typeof modifiedDate === 'object' ? modifiedDate : new Date(modifiedDate.split('-').join('/')); // to support date for all browser
    const [value, onChange] = useState(formatedSelectedDate);
    const deliveryDates = deliveryDatesResponse?.deliveryDates || [];
    const startDate = deliveryDates[0]?.date;
    const endDate = deliveryDates[deliveryDates.length - 1]?.date;

    let body = {};
    if (!isEmpty(ROSSOrder)) {
        const addressDetail = ROSSOrder?.recipientProfiles?.[0]?.addressDetail[0];
        const item = ROSSOrder?.items?.[0];
        const orderStartDate = item?.arrivalStartDate !== '' ? DDMMMYY(item?.arrivalStartDate) : '';
        const state = isRecipientAddressChanged ? modifiedRecipientAddress?.state : addressDetail?.state || '';
        const zipCode = isRecipientAddressChanged ? modifiedRecipientAddress?.zipCode : addressDetail?.zipCode || '';
        body = {
            country: 'USA',
            state,
            deliveryDate: DDMMMYY(modifiedDate) || '',
            locationType: addressDetail?.addressType || '1',
            productSku: item?.productSku || '',
            startDate: orderStartDate,
            sourceSystem: 'WEB',
            zipCode,
            brandCode: item?.productBrand || '1001',
            itemQuantity: addressDetail?.quantity || '',
            itemTypeCode: '',
            promCode: Helper?.getPromCode(item?.productBrand, promCodeFlag) || '',
            fullFillSku: '',
            lineNumber: '',
            recipNumber: ROSSOrder?.recipientProfiles?.[0]?.recId || '',
            orderType: '',
        };
    } else {
        const firstItemDetail = itemDetail?.[0];
        const orderStartDate = firstItemDetail?.arrivalStartDate !== '' ? DDMMMYY(firstItemDetail?.arrivalStartDate) : '';
        const orderFullFillSku = firstItemDetail?.fulfillSku !== null ? firstItemDetail?.fulfillSku !== null : '';
        const state = isRecipientAddressChanged ? modifiedRecipientAddress?.state : recipient?.address?.state || '';
        const zipCode = isRecipientAddressChanged ? modifiedRecipientAddress?.zipCode : recipient?.address?.zipcode || '';
        body = {
            country: 'USA',
            state,
            deliveryDate: DDMMMYY(modifiedDate) || '',
            locationType: recipient?.address?.addressType || '1',
            productSku: firstItemDetail?.productSku || '',
            startDate: orderStartDate || '',
            sourceSystem: 'WEB',
            zipCode,
            brandCode: firstItemDetail.productBrand || '1001',
            itemQuantity: firstItemDetail?.quantity || '',
            itemTypeCode: '',
            promCode: Helper?.getPromCode(firstItemDetail?.productBrand, promCodeFlag) || '',
            fullFillSku: orderFullFillSku || '',
            lineNumber: '',
            recipNumber: recipient?.recId || '',
            orderType: '', // leave as empty string or will break api
        };
    }
    useEffect(() => {
        fetchDeliveryDates(body);
    }, []);

    useEffect(() => () => {
        setModifiedDate(value);
        const selectedDate = deliveryDates?.find(({ date }) => date === DDMMMYY(value));
        getModifiedDeliveryMethod(selectedDate);
        if (productAvilableStatus === 200) {
            clearProductAvilability();
        }
    }, [value]);

    const goToNextTab = () => {
        if (modifyEligibility?.isCardMsgModifiable === false) {
            checkForConfirmationScreen(true);
            setModifiedDate(value);
        } else {
            setModifiedDate(value);
            changeTabs(2);
        }
    };

    if (deliveryDates.length === 0 && !responseStatus) {
        return (
            <div className={classes.loadingContainer}>
                <p>Pulling up available delivery dates...</p>
                <CircularProgress color="inherit"/>
            </div>
        );
    }

    if (deliveryDates.length === 0 && responseStatus === 200) {
        return (
            <>
                <div className={classes.deliveryDateBlank}>
                    <p>The date cannot be modified right now. Please try again later.</p>
                </div>
                <Grid container xs={12} spacing={2} className={classes.buttonWrapInit}>
                    <Grid item xs={6}>
                        <Button
                            className={classes.backButton}
                            variant="outlined"
                            fullWidth
                            disabled={!modifyEligibility?.isRecipientModifiable}
                            onClick={() => changeTabs(0)}
                        >Go Back
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button className={classes.nextButton} variant="contained" fullWidth color="primary" onClick={goToNextTab}>Next</Button>
                    </Grid>
                </Grid>
            </>
        );
    }

    const getDisabledDate = (date) => {
        const formatedDate = DDMMMYY(date);
        const deliveryDatesArr = [];
        deliveryDates.forEach((e) => {
            deliveryDatesArr.push(e.date);
        });
        const isDisabledDate = !deliveryDatesArr.includes(formatedDate);
        return isDisabledDate;
    };

    return (
        <div>
            <Grid xs={12} container spacing={3} className={classes.modifyDateWrapper}>
                <Grid xs={12} sm={6} md={6} item>
                    <Calendar
                        onChange={onChange}
                        value={value}
                        tileDisabled={({ date }) => getDisabledDate(date)}
                        minDate={new Date(startDate)}
                        maxDate={new Date(endDate)}
                        view="month"
                        calendarType="US"
                        next2Label={null}
                        prev2Label={null}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} container item justify="center" className={classes.selectedDateDetails}>
                    <Grid className={classes.originalDate}><div className={classes.title}>Original Delivery Date:</div>{dateMMMMDDYYYY(originalDate)}</Grid>
                    <Grid className={classes.modifiedDateWrap}>
                        <span className={classes.title}>Selected Delivery Date:</span>
                        <br />
                        {(dateMMMMDDYYYY(originalDate) === dateMMMMDDYYYY(value)) ? 'Choose One' : dateMMMMDDYYYY(value)}
                    </Grid>
                    { productAvilableStatus === 200 && productAvailable === 'false' && dateMMMMDDYYYY(originalDate) !== dateMMMMDDYYYY(value) ? (
                        <Grid className={classes.error}>
                            <span>Product is not available for this date. Please select a different date.</span>
                        </Grid>
                    ) : (
                        null
                    )}
                </Grid>
            </Grid>
            <Grid container xs={12} spacing={2} className={classes.buttonWrap}>
                <Grid item xs={6}>
                    <Button className={classes.backButton} variant="outlined" disabled={!modifyEligibility?.isRecipientModifiable} fullWidth onClick={() => changeTabs(0)}>Go Back</Button>
                </Grid>
                <Grid item xs={6}>
                    <Button className={classes.nextButton} variant="contained" fullWidth color="primary" onClick={goToNextTab}>Next</Button>
                </Grid>
            </Grid>
        </div>
    );
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        productAvailable: newState.productAvailable,
        productAvilableStatus: newState.productAvilableStatus,
    };
};

ModifyDate.propTypes = {
    classes: object.isRequired,
    fetchDeliveryDates: func.isRequired,
    deliveryDatesResponse: shape({
        deliveryDates: array.isRequired,
    }).isRequired,
    ROSSOrder: object.isRequired,
    itemDetail: array.isRequired,
    recipient: object.isRequired,
    setModifiedDate: func.isRequired,
    responseStatus: number.isRequired,
    modifiedDate: string.isRequired,
    changeTabs: func.isRequired,
    originalDate: string.isRequired,
    getModifiedDeliveryMethod: func.isRequired,
    isRecipientAddressChanged: bool.isRequired,
    modifiedRecipientAddress: object.isRequired,
    productAvilableStatus: number.isRequired,
    productAvailable: string.isRequired,
    clearProductAvilability: func.isRequired,
    promCodeFlag: bool.isRequired,
    modifyEligibility: shape({
        isRecipientModifiable: bool,
        isDeliveryDateModifiable: bool,
        isCardMsgModifiable: bool,
    }).isRequired,
    checkForConfirmationScreen: func.isRequired,
};

const StyledModifyDate = withStyles(styles)(ModifyDate);
export default connect(mapStateToProps)(StyledModifyDate);
